// extracted by mini-css-extract-plugin
export var container = "styles-module--container--pIAJn";
export var imgHome = "styles-module--imgHome--VSc2t";
export var imgLogo = "styles-module--imgLogo--3YTPw";
export var sectionDownload = "styles-module--sectionDownload--BRjBW";
export var imgAppStore = "styles-module--imgAppStore--3IAES";
export var roundButton = "styles-module--roundButton--ebdlu";
export var buttonContainer = "styles-module--buttonContainer--vm++A";